import { ButtonTs, Throbber } from '@lt/components';
import { useTranslation } from '@lt/localization';
import type { MouseEventHandler } from 'react';
import React from 'react';
import type { OptionState } from 'src/routes/Checkout/store/client/types';
import styled, { css } from 'styled-components';
import {
  TEST_ID_TOURIST_OPTION_CANCEL_DELETE,
  TEST_ID_TOURIST_OPTION_CONFIRM_DELETE,
} from './constants';

type Props = {
  handleCancelDelete: MouseEventHandler<HTMLButtonElement>;
  handleConfirmDelete: MouseEventHandler<HTMLButtonElement>;
  state: OptionState;
  isMobile: boolean;
};

const TouristOptionButtons = ({
  handleCancelDelete,
  handleConfirmDelete,
  state,
  isMobile,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <CancelButton
        onClick={handleCancelDelete}
        variant="functional"
        size="flex"
        $loading={state === 'deleting'}
        data-testid={TEST_ID_TOURIST_OPTION_CANCEL_DELETE}
      >
        {t('checkout.touristForm.name.cancel')}
      </CancelButton>
      <DeleteButton
        onClick={handleConfirmDelete}
        variant="default"
        size="flex"
        $loading={state === 'deleting'}
        $isMobile={isMobile}
        disabled={state === 'deleting'}
        data-testid={TEST_ID_TOURIST_OPTION_CONFIRM_DELETE}
      >
        {state === 'deleting' ? (
          <StyledThrobber embed color="#919499" size={20} />
        ) : (
          t('checkout.touristForm.name.delete')
        )}
      </DeleteButton>
    </>
  );
};

const StyledThrobber = styled(Throbber)`
  margin-top: 4px;
`;

const CancelButton = styled(ButtonTs)<{ $loading: boolean }>`
  margin-right: 16px;
  color: #007aff;

  ${(props) =>
    props.$loading &&
    css`
      opacity: 0.2;
    `}
`;

const DeleteButton = styled(ButtonTs)<{
  $loading: boolean;
  $isMobile: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d0021b;
  background: transparent;
  color: #d0021b;
  padding: 6px 8px;
  min-height: 40px;

  ${(props) =>
    props.$loading &&
    css`
      width: 70px;
      border-color: #919499;
    `}

  ${(props) =>
    props.$isMobile
      ? css`
          width: 126px;
        `
      : null}

    &:hover {
    background: transparent;
    color: #d0021b;
    border: 1px solid #d0021b;
  }
`;

export default TouristOptionButtons;
